import script from "./industry-contract-requirement-card.vue?vue&type=script&lang=tsx&setup=true"
export * from "./industry-contract-requirement-card.vue?vue&type=script&lang=tsx&setup=true"

import "./industry-contract-requirement-card.vue?vue&type=style&index=0&id=2eaacc84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eaacc84"]])

export default __exports__